import { render, staticRenderFns } from "./submit-intention.vue?vue&type=template&id=45be94fe"
import script from "./submit-intention.vue?vue&type=script&lang=js"
export * from "./submit-intention.vue?vue&type=script&lang=js"
import style0 from "./submit-intention.vue?vue&type=style&index=0&id=45be94fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports